<!-- ProductListBody.vue -->
<template>
	<div class="ui-product-list">
			<div class="ui-product-body">
				<div class="top_title">{{ repurchase.act_name }}</div>
				<div style="margin-left: 10px;color: #333333;">
					适用范围:<i style="margin-left: 10px;font-size:14px;">{{ actRange(repurchase)}}</i>
				</div>
				<div style="margin-left: 10px;color: #333333;">
					<span style="font-size:14px;">{{ actDesc(repurchase)}}</span>
				</div>
				<div class="list" v-for="(gift,index) in repurchase.gift">
					<div class="ui-image-wrapper">
						<img style="z-index: 300;position:absolute;top: 2px;left: 2px;" src="../../../assets/image/change-icon/repurchase@2x.png" alt="" srcset="">
						<img src="../../../assets/image/change-icon/default_image_02@2x.png" class="product-img" v-if='isPhotoEmpty(gift)'>
						<img class="product-img" v-bind:src="getPhotoUrl(gift)" v-if='!isPhotoEmpty(gift)' data-src='../../../assets/image/change-icon/default_image_02@2x.png' >
						<span v-if="gift.good_stock == 0">已售罄</span>
						<span v-if="gift.good_stock > 0 && gift.good_stock <= 10">仅剩{{ gift.good_stock }}件</span>
					</div>
					<div class="flex-right">
						<div class="product-header">
							<img class="promos-icon" v-if="gift.promos && gift.promos.length > 0" src="../../../assets/image/change-icon/c0_sale@2x.png" />
							<h3 class="title clear-bottom" style="-webkit-box-orient:vertical">{{ gift.name }}</h3>
						</div>
						<div class="price">
							<span>￥{{ utils.currencyPrice(gift.shop_price) }}</span>
						</div>
						<div class="flashsale">
							<span style="font-size: 16px;color:red;">换购价格:￥{{ gift.formated_price }}</span>
						</div>
						<div class="sendway">
							<span v-if="gift.self_employed" class="self-support">自营</span>
							<span>{{gift.review_rate}}好评</span>
							<span>销量{{gift.sales_count}}</span>
							<img src="../../../assets/image/change-icon/add@2x.png" @click.stop="_redemptioncart(gift)">
						</div>
					</div>
				</div>
			</div>
	</div>
</template>

<script>
import { Toast, Indicator ,MessageBox } from 'mint-ui';
import { mapState, mapMutations } from 'vuex';
import { redemptioncart } from '../../../api/cart';
import { cartQuantity } from '../../../api/cart';

export default{
	data(){
		return{
		}
	},
	props: ['repurchase', 'act_id'],
	computed: {
		...mapState({
			isOnline: state => state.auth.isOnline,
			user: state => state.auth.user,
		}),
	},
	methods: {
		...mapMutations({
				setCartNumber: 'setCartNumber'
			}),
		getTime(unixTimestamp){
			let date  = new Date(Number(unixTimestamp)*1000)
			let fmt = fmt || 'm-d H:i';
			var map = {
				Y: function() { return date.getFullYear(); },
				m: function() { return (date.getMonth() < 9 ? '0': '') + (date.getMonth() + 1); },
				d: function() { return (date.getDate() < 10 ? '0': '') + date.getDate(); },
				H: function() { return (date.getHours() < 10 ? '0': '') + date.getHours(); },
				i: function() { return (date.getMinutes() < 10 ? '0': '') + date.getMinutes(); },
				s: function() { return (date.getSeconds() < 10 ? '0': '') + date.getSeconds(); }
			};
			var rt = '';
			for(var i=0;i<fmt.length;i++){
				var cur = fmt.charAt(i);
				rt += map[cur] ? map[cur].apply(this): cur;
			}
			return rt;
		},
		actDesc(item){
			if(item.act_type_ext =='0'){
				return '不限制购买数量'
			}else{
				return '最多可以购买'+item.act_type_ext+'件'
			}
		},
		actRange(item){
			if(item.act_range =='0'){
				return '全部商品'
			}else if(item.act_range =="1"){
				return  '以下分类：'+item.act_range_desc
			}else if(item.act_range =="2"){
				return '以下品牌：'+item.act_range_desc
			}else if(item.act_range =="3"){
				return '以下商品：'+item.act_range_desc
			}
		},
		isPhotoEmpty(item) {			
			let url = this.getPhotoUrl(item)
			return url && url.length ? false : true
		},
		getPhotoUrl(item) {
			let goods_thumb = item.goods_thumb
			if (goods_thumb) {
				return goods_thumb
			}
			return null
		},

		/*
			*  getCarNumber: 获取购物车数量
			*/
		getCarNumber() {
			cartQuantity().then(res => {
				if (res) {
					this.setCartNumber(res.quantity);
				}
			})
		},
	
		/*
		 * redemptioncart: 加入购物车
		 * @param： gift 商品
		*/
		_redemptioncart(gift) {
			if (this.isOnline) {
				let  gift_good_ids = '['+gift.id+']'
				redemptioncart(this.act_id, gift_good_ids).then(res => {
					if (res) {
						this.getCarNumber();
						 MessageBox({
								title: '加入成功',
								message: gift.name + '已经加入到您的购物车里啦,去购物车查看吧！',
								confirmButtonText: '去购物车',
								confirmButtonClass: 'confirm-button-red',
								showCancelButton: true
							}).then(action => {
								if (action == 'confirm') {
									if (this.user) {
										this.$router.push({'name': 'cart', 'params': {type: 0}});
									} else {
										this.$router.push({'name': 'signin'});
									}
								}
						});
					}
				}, (error) => {
					Toast(error.errorMsg);
				});
			} else {
				this.$router.push({'name': 'signin'});
			}
		},
	}
}
</script>

<style lang='scss' scoped>
.ui-product-body {
	border-bottom: 1px solid rgba(232,234,237,1);
	.top_title{
		height: 26px;
		padding: 0px 5px;
		-webkit-box-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		align-items: center;
		border-bottom: 1px solid #F5F5F5;
		margin-left: 10px;
		margin-top: 10px;
		border-left: 2px solid #eb8419;
    font-size: 22px;
    line-height: 26px;
		color: #333333;
	}
	.list {
		display: flex;
		width: auto;
		align-items: center;
		justify-content: space-between;
		margin: 11px 10px;
		position: relative;
		div.ui-image-wrapper {
			width: 110px;
			height: 110px;
			position: relative;
			display: flex;
		  justify-content: center;
		  align-content: center;
		  align-items: center;
			flex-basis: 110px;
			flex-shrink: 0;
			background-position:center center!important;
			background: url("../../../assets/image/change-icon/default_image_02@2x.png");
			background-size:100px 100px;
			background-repeat:no-repeat;
			-webkit-background-size: cover;
			-moz-background-size: cover;
			-o-background-size: cover;
			background-size: cover;
			img.product-img{
				width: 110px;
				height: 110px;
				flex-basis: 110px;
				flex-shrink: 0;
			}
			img.product-img[lazy=loading] {
				width: 30px;
				height: 30px;
			}
			img.product-im[lazy=error] {
				width: 30px;
				height: 30px;
			}
			img.product-img[lazy=loaded] {
				width: 110px;
				height: 110px;
				flex-basis: 110px;
				flex-shrink: 0;
				background:rgba(255,255,255,1);
			}

			span {
				position: absolute;
				height:20px;
				background:rgba(243,244,245,1);
				line-height: 20px;
				text-align: center;
				font-size:14px;
				color:$primaryColor;
				width: 110px;
				bottom: 0px;
				left: 0px;
			}
		}

		span.promos {
			position: absolute;
			background: url('../../../assets/image/change-icon/label@2x.png') no-repeat;
			width: 36px;
			height: 19px;
			color: #FFFFFF;
			font-size: 10px;
			top: 0px;
			left: 0px;
			background-size: cover;
			font-weight: 100;
			line-height: 19px;
			text-align: left;
			padding-left: 5px;
		}
		.flex-right {
			padding-left: 14px;
			width: 100%;
			.title {
				color: #4E545D;
				font-size: 16px;
				font-weight: normal;

				display:-moz-box;
			  display:-webkit-box;
			    display:box;

				-webkit-line-clamp: 2;
				-moz-line-clamp: 2;

				-moz-box-orient:vertical;
				-webkit-box-orient:vertical;
				box-orient:vertical;

				overflow: hidden;
				margin-bottom: 8px;
				&.clear-bottom {
					margin-bottom: 0px;
				}
			}

			.product-header {
				display: flex;
	            align-items: center;
			}
			.promos-icon {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
			.sub-title {
				color: #55595F;
				font-size: 12px;

				display:-moz-box;
			  display:-webkit-box;
			  display:box;

				-webkit-line-clamp: 1;
				-moz-line-clamp: 1;

				-moz-box-orient:vertical;
				-webkit-box-orient:vertical;
				box-orient:vertical;

				overflow: hidden;
				margin-bottom: 8px;
			}
			.price {
				margin-bottom: 8px;
				span {
					&:first-child {
						color: $primaryColor;
						font-size: 16px;
						text-decoration: line-through;
					}
				}
			}
			.flashsale {
				margin-bottom: 8px;
				span {
					&:first-child {
						color: $primaryColor;
						font-size: 12px;
					}
				}
			}
			.sendway {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 12px;
				font-weight: 'Regular';
				span{
					color: #7C7F88;
					&.self-support {
						font-size: 10px;
						color: $primaryColor;
						border: 1px solid $primaryColor;
						border-radius: 2px;
						width: 32px;
					    height: 16px;
					    line-height: 16px;
					    text-align: center;
					}
				}
				img {
					width: 22px;
					height: 20px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/page/repurchase-list/child/ProductListBody.vue